import hero960 from "@/assets/hero-engraving-960.webp";
import hero1280 from "@/assets/hero-engraving-1280.webp";
import hero1600 from "@/assets/hero-engraving-1600.webp";
import hero1920 from "@/assets/hero-engraving.webp";

/** 1280w matches a typical mobile Lighthouse viewport at 2.6–3x DPR. */
export const HERO_SRC = hero1280;
export const HERO_SRCSET = `${hero960} 960w, ${hero1280} 1280w, ${hero1600} 1600w, ${hero1920} 1920w`;
export const HERO_SIZES = "100vw";
export const HERO_WIDTH = 1920;
export const HERO_HEIGHT = 1280;
export const HERO_ALT =
  "Laser engraving machine tracing a fine logo into a brushed metal tumbler";
